<template>
  <div class="user">
    <div class="login">
      <ul class="login-tabbar">
        <li
          class="login-tabbar__item"
          :class="{ 'login-tabbar__item--active': loginMode === 'weixi' }"
          @click="toggleLoginMode('weixi')"
        >
          微信登录
        </li>
        <li
          class="login-tabbar__item"
          :class="{ 'login-tabbar__item--active': loginMode === 'phone' }"
          @click="toggleLoginMode('phone')"
        >
          手机号登录
        </li>
        <li
          class="login-tabbar__item"
          @click="toggleLoginMode('password')"
          :class="{ 'login-tabbar__item--active': loginMode === 'password' }"
        >
          密码登录
        </li>
      </ul>

      <ul class="login-form-content">
        <li class="login-form-content__phone" v-if="loginMode === 'weixi'">
          <div class="dialog-login" v-loading="loading">
            <div style="margin-bottom: 20px" class="link-type">
              {{ countdown }} 秒后二维码失效
            </div>
            <img class="image" :src="mapSrc" alt="" />
            <div style="margin-top: 20px">
              <el-button type="text" class="link-type" @click="onRefresh"
                >刷新二维码后，重新扫码登录</el-button
              >
            </div>
          </div>
          <div style="text-align: center">
            扫码登录平台，表示你同意<a
              :href="'/platformSpecification?platformSpecificationId=1'"
              target="_blank"
              style="color: #409eff"
              >用户服务协议</a
            >和<a
              :href="'/platformSpecification?platformSpecificationId=2'"
              target="_blank"
              style="color: #409eff"
              >隐私政策</a
            >
          </div>
        </li>
        <li class="login-form-content__phone" v-if="loginMode === 'phone'">
          <el-form
            ref="userForm"
            :model="userForm"
            :rules="userRules"
            key="phone"
          >
            <el-form-item prop="phoneNumber">
              <el-input
                v-model="userForm.phoneNumber"
                placeholder="输入手机号"
                maxlength="11"
                class="input-with-select"
              >
              </el-input>
            </el-form-item>
            <el-form-item prop="verifyCode">
              <el-input v-model="userForm.verifyCode" placeholder="输入验证码">
                <el-button
                  type="primary"
                  slot="append"
                  :disabled="disabled"
                  @click="getVerifyCode"
                  >{{ valiBtn }}</el-button
                >
              </el-input>
            </el-form-item>
            <el-form-item style="margin-top: -15px">
              <el-checkbox v-model="checked"
                >我接受<a
                  :href="'/platformSpecification?platformSpecificationId=1'"
                  target="_blank"
                  style="color: #409eff"
                  >用户服务协议</a
                >和<a
                  :href="'/platformSpecification?platformSpecificationId=2'"
                  target="_blank"
                  style="color: #409eff"
                  >隐私政策</a
                ></el-checkbox
              >
            </el-form-item>
          </el-form>
        </li>
        <li
          class="login-form-content__email"
          v-else-if="loginMode === 'password'"
        >
          <el-form
            key="password"
            ref="userForm"
            :model="userForm"
            :rules="userRules"
          >
            <el-form-item prop="phoneNumber">
              <el-input
                v-model="userForm.phoneNumber"
                placeholder="请输入手机号"
                maxlength="11"
                autocomplete="on"
              ></el-input>
            </el-form-item>
            <el-form-item prop="userPassword">
              <el-input
                class="input-with-icon"
                placeholder="请输入密码"
                v-model="userForm.userPassword"
                :type="passwordInputType"
              >
                <i
                  slot="suffix"
                  :class="
                    passwordInputType === 'password'
                      ? 'el-icon-turn-off'
                      : 'el-icon-open'
                  "
                  @click="togglePasswordInputType"
                />
              </el-input>
            </el-form-item>
            <el-form-item style="margin-top: -15px">
              <el-checkbox v-model="pwdchecked"
                >我接受<a
                  :href="'/platformSpecification?platformSpecificationId=1'"
                  target="_blank"
                  style="color: #409eff"
                  >用户服务协议</a
                >和<a
                  :href="'/platformSpecification?platformSpecificationId=2'"
                  target="_blank"
                  style="color: #409eff"
                  >隐私政策</a
                ></el-checkbox
              >
            </el-form-item>
          </el-form>
        </li>
      </ul>

      <div class="login__button" v-if="loginMode !== 'weixi'">
        <bytedance-button
          :loading="loading"
          @click="handlerLogin"
          @keydown.enter.native="handlerLogin"
          type="primary"
          size="large"
          tabindex="0"
          ><span v-if="!loading">登 录</span>
          <span v-else>登 录 中...</span></bytedance-button
        >
      </div>
      <div style="float: right; margin-top: 10px" v-if="register">
        <router-link class="link-type" to="/register">立即注册</router-link>
        <router-link class="link-type" to="/forgotPassword"
          >忘记密码</router-link
        >
      </div>
    </div>

    <Verify
      @success="success"
      :mode="'pop'"
      :captchaType="captchaType"
      :imgSize="{ width: '330px', height: '155px' }"
      ref="verify"
    ></Verify>
  </div>
</template>
<script>
import {
  getUnlimitedQRCode,
  checkSceneLoginStatus,
  sendCode,
} from "@/api/index.js";
import Verify from "./../components/verifition/Verify";
import { setToken } from "@/helper/auth";
import { encryptSm4 } from "@/helper/sm4";
export default {
  name: "user",
  components: {
    Verify,
  },
  data() {
    return {
      captchaType: "",
      valiBtn: "获取验证码",
      disabled: false,
      loginMode: "password",
      checked: false,
      pwdchecked: false,
      userForm: {
        phoneNumber: "",
        verifyCode: "",
        userPassword: "",
      },
      userRules: {
        phoneNumber: [
          {
            required: true,
            pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
            message: "请输入请输入合法的手机号",
            trigger: "blur",
          },
        ],
        verifyCode: [
          { required: true, message: "请输入验证码", trigger: "blur" },
        ],
        userPassword: [
          { required: true, trigger: "blur", message: "请输入您的密码" },
          {
            min: 5,
            max: 20,
            message: "用户密码长度必须介于 5 和 20 之间",
            trigger: "blur",
          },
          {
            pattern: /^[^<>"'|\\]+$/,
            message: "不能包含非法字符：< > \" ' \\ |",
            trigger: "blur",
          },
        ],
      },
      passwordInputType: "password",
      loading: false,
      // 注册开关
      register: true,
      mapSrc: "",
      scene: "",
      countdown: 300,
      pollTimer: "",
      timer: null,
    };
  },
  created() {},
  methods: {
    toggleLoginMode(mode) {
      this.loginMode = mode;
      if (mode == "weixi") {
        this.register = false;
        this.scene = this.generateRandomString(32);
        this.loading = true;
        this.UnlimitedQRCode();
        this.startCountdown();
        this.startPolling();
      } else if (mode == "password") {
        this.register = true;
        this.countdown = 300;
        clearInterval(this.pollTimer);
        clearInterval(this.timer);
      } else {
        this.register = false;
        this.countdown = 300;
        clearInterval(this.pollTimer);
        clearInterval(this.timer);
      }
    },

    //随机生成32位动态码
    generateRandomString(length) {
      const characters =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      let result = "";
      const charactersLength = characters.length;
      for (let i = 0; i < length; i++) {
        result += characters.charAt(
          Math.floor(Math.random() * charactersLength)
        );
      }
      return result;
    },

    //刷新二维码
    onRefresh() {
      this.countdown = 300;
      clearInterval(this.pollTimer);
      clearInterval(this.timer);
      this.toggleLoginMode("weixi");
    },

    //获取二维码图片
    UnlimitedQRCode() {
      getUnlimitedQRCode(this.scene).then((res) => {
        this.loading = false;
        let blob = new Blob([res]); // 返回的文件流数据
        let url = window.URL.createObjectURL(blob); // 将他转化为路径
        this.mapSrc = url; // 将转换出来的路径赋值给变量，其实和上一步结合就可以
      });
    },

    //二维码失效计时器
    startCountdown() {
      this.timer = setInterval(() => {
        if (this.countdown <= 0) {
          clearInterval(this.timer);
          this.$message.warning("二维码已过期");
          return;
        }
        this.countdown--;
      }, 1000);
    },

    //轮询查询是否扫描登入成功
    async startPolling() {
      const poll = async () => {
        try {
          await checkSceneLoginStatus(this.scene).then((res) => {
            if (res.code == 200) {
              clearInterval(this.pollTimer);
              clearInterval(this.timer);
              setToken(res.data.token);
              this.$store.commit("SET_TOKEN", res.data.token);
              this.$store.commit("SET_STATUS", "true");
              this.$store.commit("SET_PHONENUMBER", res.data.phoneNumber);
              this.$message({
                showClose: true,
                message: "登录成功",
                type: "success",
              });
              this.getPersonalInfo();
              this.$router.go(-1);
            }
          });
        } catch (error) {
          console.error("轮询异常:", error);
        }
      };

      this.pollTimer = setInterval(poll, 3000);
      poll(); // 立即执行第一次
    },

    success(params) {
      // params 返回的二次验证参数, 和登录参数一起回传给登录接口，方便后台进行二次验证
      this.tackBtn(); //验证码倒数60秒
      this.$set(params, "phoneNumber", this.userForm.phoneNumber);
      sendCode(params).then((res) => {});
    },

    //获取验证码 并只验证手机号 是否正确
    getVerifyCode() {
      let isValid = true;
      this.$refs["userForm"].validateField(["phoneNumber"], (err) => {
        if (err) {
          isValid = false;
          console.log("未通过");
          return;
        } else {
          console.log("已通过");
        }
      });
      if (isValid) {
        this.captchaType = Math.random() < 0.5 ? "blockPuzzle" : "clickWord";
        this.$refs.verify.show();
      }
    },

    tackBtn() {
      //验证码倒数60秒
      let time = 60;
      let timer = setInterval(() => {
        if (time == 0) {
          clearInterval(timer);
          this.valiBtn = "获取验证码";
          this.disabled = false;
        } else {
          this.disabled = true;
          this.valiBtn = time + "秒后重试";
          time--;
        }
      }, 1000);
    },

    handlerLogin() {
      this.$refs.userForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          if (this.loginMode == "phone") {
            if (this.checked) {
              let postBody = {
                phoneNumber: this.userForm.phoneNumber,
                verifyCode: encryptSm4(this.userForm.verifyCode),
              };
              this.$store
                .dispatch("verifyCodeLogin", postBody)
                .then((res) => {
                  if (res.code == 200) {
                    this.$message({
                      showClose: true,
                      message: "登录成功",
                      type: "success",
                    });
                    this.getPersonalInfo();
                    this.loading = false;
                    this.$router.go(-1);
                  } else {
                    this.$message({
                      showClose: true,
                      message: res.msg,
                      type: "warning",
                    });
                    this.loading = false;
                  }
                })
                .catch(() => {
                  this.loading = false;
                });
            } else {
              this.$message.error("请先阅读并勾选用户服务协议和隐私政策");
            }
          } else if (this.loginMode == "password") {
            if (this.pwdchecked) {
              let postBody = {
                phoneNumber: this.userForm.phoneNumber,
                userPassword: encryptSm4(this.userForm.userPassword),
              };
              this.$store
                .dispatch("Login", postBody)
                .then((res) => {
                  if (res.code == 200) {
                    this.$message({
                      showClose: true,
                      message: "登录成功",
                      type: "success",
                    });
                    this.getPersonalInfo();
                    this.loading = false;
                    this.$router.go(-1);
                  } else {
                    this.$message({
                      showClose: true,
                      message: res.msg,
                      type: "warning",
                    });
                    this.loading = false;
                  }
                })
                .catch(() => {
                  this.loading = false;
                });
            } else {
              this.$message.error("请先阅读并勾选用户服务协议和隐私政策");
            }
          }
        }
      });
    },

    //获取个人信息
    getPersonalInfo() {
      this.getUserOpen();
      this.$store.dispatch("GetInfo").then((res) => {
        if (res.code == 200) {
          if (res.data.reMiniProgramPerson) {
            if (res.data.reMiniProgramPerson.profilePhoto) {
              this.PreviewUrlPhoto(res.data.reMiniProgramPerson.profilePhoto);
            }
          }
        }
      });
    },

    //获取头像
    PreviewUrlPhoto(profilePhoto) {
      this.$store.dispatch("PreviewUrlPhoto", profilePhoto);
    },

    getUserOpen() {
      this.$store.dispatch("GetUserOpen");
    },

    togglePasswordInputType() {
      this.passwordInputType =
        this.passwordInputType === "password" ? "text" : "password";
    },
  },
};
</script>
<style lang="less">
.input-with-select {
  &__divider {
    border-color: @border-extralight-color;
    border-top-width: 0;
    margin-top: 0;
  }
  .el-select .el-input {
    width: 130px;
  }
  .el-input-group__prepend {
    background-color: #fff;
  }
}
.input-with-icon {
  .el-input__suffix {
    cursor: pointer;
    margin-right: 3px;
  }
}

.el-form-item {
  margin-bottom: 30px;
}
.el-form-item:nth-child(3) {
  margin-bottom: 10px;
}

.el-checkbox__input.is-checked + .el-checkbox__label {
  color: #66716c;
}
</style>
<style scoped lang="less">
.user {
  height: calc(100vh - 380px);
  display: flex;
  justify-content: center;
  align-items: center;
}
.login {
  width: 500px;
  &-tabbar {
    display: flex;

    &__item {
      padding-bottom: 8px;
      margin-right: 30px;
      cursor: pointer;
      font-weight: @font-weight-primary;
      font-size: @font-size-large;
      color: @secondary-text-color;
      &:hover {
        color: @main-color;
      }
      &--active {
        border-bottom: 2px solid @main-color;
        color: @main-color;
      }
    }
  }

  &-form-content {
    margin: 40px 0 0 0;
  }
  .link-type {
    color: #337ab7;
    margin-right: 10px;
    font-size: 16px;
  }
}

.dialog-login {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .image {
    width: 200px;
  }
}

.login-code {
  width: 33%;
  height: 38px;
  float: right;

  img {
    cursor: pointer;
    vertical-align: middle;
  }
}
</style>
